import React from "react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";

export default function QuizThankYouPage() {
  return (
    <div className="min-h-screen bg-paper text-nearblack">
      <meta name="robots" content="noindex,nofollow" />
      <Nav heroVisible={false} />
      <main className="pt-32 md:pt-40 pb-24">
        <div className="max-w-[640px] mx-auto px-6 md:px-10">
          <h1
            className="font-serif text-nearblack leading-[1.05]"
            style={{ fontSize: "clamp(2.4rem, 5.5vw, 3.4rem)", fontWeight: 300 }}
            data-testid="quiz-thanks-headline"
          >
            Your call is booked.
          </h1>
          <p className="mt-5 text-stonegrey font-light text-[19px]">
            Here&apos;s what to expect.
          </p>
          <span className="block w-[60px] h-px bg-camel mt-8 mb-10" />

          <div className="text-nearblack font-light text-[18px] leading-[1.75] space-y-5 max-w-[580px]">
            <p>You&apos;ll receive a calendar confirmation shortly.</p>
            <p>
              The Money Clarity Call is 30 minutes. It&apos;s a real conversation — not a
              presentation, not a pitch, not a structured sales process.
            </p>
            <p>Here&apos;s what it actually is:</p>
            <ul className="space-y-3 pl-0 list-none">
              <li>— A chance to look honestly at where your money is going and what it could be doing instead</li>
              <li>— A clear explanation of how the strategies I work with actually function — in plain language, not industry jargon</li>
              <li>— A direct answer to whether any of this is relevant to your specific situation</li>
            </ul>
            <p>You don&apos;t need to prepare anything.</p>
            <p>You don&apos;t need to bring financial documents.</p>
            <p>
              You don&apos;t need to know anything about Infinite Banking or whole life insurance
              before we talk.
            </p>
            <p>
              The only thing that makes this call valuable is honesty — the same honesty you
              brought to the assessment.
            </p>
            <p className="font-serif italic text-nearblack/85">I&apos;ll see you then.</p>
            <p className="font-serif italic text-camel" style={{ fontSize: "1.45rem" }}>— Liz</p>
          </div>

          <div className="mt-16 text-stonegrey text-[13px] leading-[1.7] font-light">
            <p className="font-medium text-nearblack">Liz DiRocco</p>
            <p>Licensed Financial Professional | IBC Practitioner</p>
            <p>Penn Mutual / 1847 Financial</p>
            <p className="italic font-serif mt-1">Strategic Banking. Infinite Possibilities.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
